import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { manageUpdatePopup } from '../../features/ControlSlice'
import Popup from '../Popup'
import TaskForm from '../todo-forms/TaskForm'

const EditTodo = ({id} : any) => {
  const dispatch = useDispatch()
  const showEditPopup = useSelector((state: RootState) => state.controls.showUpdatePopup)

  const handleClosePopup = () => {
    dispatch(manageUpdatePopup(false))
  }

  return (
    
    <div>
       {
        showEditPopup === id &&
        <Popup title="Edit task" setClose={() => dispatch(manageUpdatePopup(false))}>
          <TaskForm id={id} onSubmitForm={handleClosePopup}/>
        </Popup>
      }
    </div>
  )
}

export default EditTodo